import React from "react";
import { useTranslation } from "react-i18next";

import { Images } from "../../../../../assets/images";
import {
  EMPTY_STRING,
  shutterbDashboardConstants,
} from "../../../../../constants";
import {
  convertDateToUTC,
  convertEpochTo12HourTime,
} from "../../../../../shared";
import EventDetailRow from "../../../../../shared/components/Events/EventDetailRow";
import EventActionCard from "../../../../../shared/components/Events/EventActionCard";

const EventDetail = ({
  event,
  setIsModalOpen,
  setReelModalEventId,
  setEventDetailId,
  getEventDetailByEventId,
  setIsEventDetailModalOpen,
  handleCheckStatus,
  handleMessageBoard,
  handleGalleryClick,
  isOthersEvents = false,
  sbUserId,
  activeTab,
}) => {
  const { t } = useTranslation("common");

  const isCheckinDisabled = (event?.orderItems ?? []).some(
    (oi) => oi.checkedStatus !== shutterbDashboardConstants.CREATED
  );

  const isCheckoutDisabled = (event?.orderItems ?? []).some(
    (oi) =>
      oi.checkedStatus !== shutterbDashboardConstants.CHECK_IN &&
      oi.sbUserId === sbUserId
  );

  const isGalleryDisabled = (event?.orderItems ?? []).some(
    (oi) => oi.checkedStatus === shutterbDashboardConstants.CREATED
  );

  const ianaTimezone = event?.eventLocation?.[0]?.timezone;

  return (
    <div>
      <EventDetailRow label="event type:" value={event?.eventType?.name} />
      <EventDetailRow
        label="event host:"
        value={`${event?.user.firstName} ${event?.user.lastName}`}
      />
      <EventDetailRow
        label="event date:"
        value={convertDateToUTC(event?.eventDate, ianaTimezone)}
      />
      <EventDetailRow
        label="event duration:"
        value={`${event?.duration} ${
          event?.duration <= 1 ? " hour" : " hours"
        }`}
      />
      <EventDetailRow
        label="event start time:"
        value={convertEpochTo12HourTime(event?.eventStartTime, ianaTimezone)}
      />
      <EventDetailRow
        label="shutterb start time:"
        value={convertEpochTo12HourTime(event?.sbStartTime, ianaTimezone)}
      />
      <EventDetailRow
        label="address:"
        value={event?.eventLocation[0]?.currentLocation}
      />
      <EventDetailRow
        label="apartment:"
        value={event?.apartment}
      />
      <EventDetailRow label="contact name" value={event?.contactName} />
      <EventDetailRow
        label="contact number"
        value={
          event?.phoneNumber ? (
            <a
              href={`tel:${event.phoneNumber}`}
              style={{ textDecoration: "underline" }}
            >
              {event.phoneNumber}
            </a>
          ) : (
            EMPTY_STRING
          )
        }
      />
      <EventDetailRow
        label="allow sharing gallery:"
        value={event?.isGallerySharedPermission ? t("yes") : t("no")}
      />
      <div className="d-flex flex-wrap py-2">
        {!isOthersEvents ? (
          <>
            {activeTab === shutterbDashboardConstants.UPCOMING_EVENTS && (
              <>
                <EventActionCard
                  classes="mh-100px"
                  iconSrc={Images.CheckIn}
                  iconAlt="check-in-icon"
                  disabledIcon={Images.CheckInDisabled}
                  disabledAlt="check-in-disabled-icon"
                  isDisabled={isCheckinDisabled}
                  onClick={() =>
                    handleCheckStatus(
                      event?.id,
                      shutterbDashboardConstants.CHECK_IN
                    )
                  }
                  title="check in"
                />
                <EventActionCard
                  classes="mh-100px"
                  iconSrc={Images.CheckOut}
                  iconAlt="check-out-icon"
                  disabledIcon={Images.CheckOutDisabled}
                  disabledAlt="check-out-disabled-icon"
                  isDisabled={isCheckoutDisabled}
                  onClick={() =>
                    handleCheckStatus(
                      event?.id,
                      shutterbDashboardConstants.CHECK_OUT
                    )
                  }
                  title="check out"
                />
              </>
            )}
            <EventActionCard
              classes="mh-100px"
              iconSrc={Images.Message}
              iconAlt="message-board-icon"
              onClick={() =>
                handleMessageBoard(
                  event?.id,
                  event?.user.firstName + " " + event?.user.lastName
                )
              }
              title="message board"
            />
            <EventActionCard
              classes="mh-100px"
              iconSrc={Images.Gallery}
              iconAlt="gallery-icon"
              disabledIcon={Images.GalleryDisabled}
              disabledAlt="gallery-disabled-icon"
              isDisabled={isGalleryDisabled}
              onClick={() => {
                handleGalleryClick(event?.id);
              }}
              title="gallery"
            />
            <EventActionCard
              classes="mh-100px"
              iconSrc={Images.EventDetails}
              iconAlt="shot-list-icon"
              onClick={() => {
                getEventDetailByEventId(event?.id);
                setEventDetailId(event?.id);
                setIsEventDetailModalOpen(true);
              }}
              title="shot list"
            />
            <EventActionCard
              classes="mh-100px"
              iconSrc={Images.Reel}
              iconAlt="recap-details-icon"
              disabledIcon={Images.ReelDisabled}
              disabledAlt="recap-details-icon-disabled"
              isDisabled={!event?.isReelExist}
              onClick={() => {
                setReelModalEventId(event?.id);
                setIsModalOpen((prev) => !prev);
              }}
              title="view recap details"
            />
          </>
        ) : (
          <EventActionCard
            classes="mh-100px"
            iconSrc={Images.Gallery}
            iconAlt="gallery-icon"
            disabledIcon={Images.GalleryDisabled}
            disabledAlt="gallery-disabled-icon"
            isDisabled={false}
            onClick={() => {
              handleGalleryClick(event?.id, true);
            }}
            title="gallery"
          />
        )}
      </div>
    </div>
  );
};

export default EventDetail;
